const loaders = reactive<{ [key: string]: boolean }>({
  payment: false,
});

export function useLoader() {
  const toggleLoader = ({ type, state }: { type: string, state: string | boolean }) => {
    loaders[type] = typeof state === 'boolean' ? state : !loaders[type];
  };

  return { loaders, toggleLoader };
}
